/*
  Carry "how many bulbs this fixture takes" onto the bulb the shopper picks.

  A fixture takes a known number of bulbs (custom.bulb_count), but every way of
  buying one opens at a quantity of 1. There are two routes out of the "Bulbs
  for this fixture" block and this handles both:

    * Choose options  — opens Craft's quick-add modal in place. The form is
      fetched on click, so an observer catches the quantity field when it
      appears.
    * the card itself — a plain link to the bulb's own product page, which
      knows nothing about the fixture it came from. The count rides along in
      the url (?bulbs=N) and is applied there.

  What this does NOT do, deliberately: add anything to the cart. It sets the
  value of a quantity field the shopper can see and change. They may own bulbs
  already, or be buying two fixtures — the number is a sensible default, not a
  decision. It also never touches a quantity that is not still at the field's
  minimum, because anything else is a choice already made.

  SCOPING of the modal case keys on the button that was clicked, not on where
  the form ends up: Craft renders <quick-add-modal> as a direct child of <body>,
  so a DOM-scope test excludes the very input this is meant to set.

  The markup is identical in Craft 13.0.1 and 15.4.1: <quantity-input> wrapping
  input.quantity__input[name="quantity"] with min and step.
*/
(function () {
  'use strict';

  var MARK = 'bulbQtyApplied';
  var PARAM = 'bulbs';
  var BLOCK = '.complementary-products';

  function countHere() {
    var h = document.querySelector('[data-bulb-count]');
    var n = h ? parseInt(h.getAttribute('data-bulb-count'), 10) : 0;
    return n > 1 ? n : 0;          // 1 is already the default everywhere
  }

  function wantedFromUrl() {
    try {
      var n = parseInt(new URLSearchParams(location.search).get(PARAM), 10);
      return n > 1 && n <= 99 ? n : 0;
    } catch (e) {
      return 0;
    }
  }

  function prefill(input, wanted) {
    if (!input || !wanted || input.dataset[MARK]) return false;
    var min = parseInt(input.min, 10) || 1;
    var current = parseInt(input.value, 10);
    if (current !== min) {                 // the shopper has already chosen
      input.dataset[MARK] = 'skipped';
      return false;
    }
    var step = parseInt(input.step, 10) || 1;
    var max = parseInt(input.max, 10);
    var value = Math.max(min, Math.round(wanted / step) * step);
    if (!isNaN(max) && max > 0) value = Math.min(value, max);
    input.dataset[MARK] = '1';
    input.value = String(value);
    // Craft's quantity-input listens for change to update its +/- buttons. It
    // does not submit anything.
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // ---- the card link: carry the count to the bulb's own page ----------------

  function tagLinks(root, wanted) {
    if (!wanted || !root || !root.querySelectorAll) return;
    var blocks = [];
    if (root.matches && root.matches(BLOCK)) blocks.push(root);
    if (root.closest && root.closest(BLOCK)) blocks.push(root);
    Array.prototype.push.apply(blocks, root.querySelectorAll(BLOCK));
    blocks.forEach(function (b) {
      b.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf(PARAM + '=') !== -1) return;
        a.setAttribute('href',
                       href + (href.indexOf('?') === -1 ? '?' : '&') + PARAM + '=' + wanted);
      });
    });
  }

  // ---- the quick-add modal -------------------------------------------------

  function start() {
    var here = countHere();
    var armed = false;

    // a quick-add opener inside the bulbs block, and only there
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('[data-product-url]');
      if (opener && opener.closest(BLOCK)) armed = true;
    }, true);

    // this page WAS reached from a fixture's bulb block: set its own quantity
    var fromUrl = wantedFromUrl();
    if (fromUrl) {
      document.querySelectorAll('input.quantity__input[name="quantity"]')
        .forEach(function (i) {
          if (!i.closest('quick-add-modal')) prefill(i, fromUrl);
        });
    }

    tagLinks(document, here);

    new MutationObserver(function (records) {
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          tagLinks(node, here);
          if (!armed) return;
          var modal = node.closest && node.closest('quick-add-modal');
          if (!modal) return;
          var inputs = node.matches && node.matches('input.quantity__input[name="quantity"]')
            ? [node]
            : [].slice.call(node.querySelectorAll('input.quantity__input[name="quantity"]'));
          for (var i = 0; i < inputs.length; i++) {
            if (prefill(inputs[i], here)) {
              armed = false;                 // one modal, one prefill
              return;
            }
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
